import React, { Component } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faCircle, faCog } from '@fortawesome/free-solid-svg-icons';

import serverStorage from '../util/serverStorage';

export default class BlockUpdateButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: null
        };
    }

    componentDidMount() {
        serverStorage.getItem('blockupdate').then(value => this.setState({ checked: value || false }));
    }

    handleToggle = async (event) => {
        const value = !this.state.checked;
        this.setState({ checked: value }); // assume success

        const success = await serverStorage.setItem('blockupdate', value);
        if (!success) this.setState({ checked: !value }); // revert
    }

    render() {
        return (
            <button type="button" disabled={this.state.checked === null} className={'btn btn-primary text-nowrap' + (this.state.checked ? ' active' : '')} onClick={this.handleToggle}>
                <Tooltip title="Prevents other users from manually updating your characters. However, please be aware that Data for Azeroth automatically updates characters for a variety of reasons.">
                    <span><FontAwesomeIcon icon={this.state.checked === null ? faCog : (this.state.checked ? faCheckCircle : faCircle)} spin={this.state.checked === null} /> Block Updates</span>
                </Tooltip>
            </button>
        );
    }
}